import { useCallback, useEffect, useRef } from "react";
import { useCopyToClipboard } from "usehooks-ts";

import useToggle from './use-toggle';

export default function useDelayedCopyTopClipboard (delay = 1500) {
  const [copiedContent, copyToClipboard] = useCopyToClipboard();
  const [isCopied, toggleIsCopied] = useToggle(false);
  const timeoutRef = useRef<NodeJS.Timeout>(null);

  const copy = useCallback(
    async (text: string) => {
      toggleIsCopied();
      await copyToClipboard(text);
      timeoutRef.current = setTimeout(() => toggleIsCopied(), delay);
    },
    [copyToClipboard, toggleIsCopied, delay]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return [isCopied, copy, copiedContent] as const;
}
